import { createCustomElement } from '@angular/elements';
import { createApplication } from '@angular/platform-browser';

import { appConfig } from '@fb/app.config';
import 'zone.js';
import { AppComponent } from '@fb/app.component';
import { AiChatPageComponent } from '@fb/components/ai-chat-page/ai-chat-page.component';
import { SupportFormComponent } from '@fb/components/support-form/support-form.component';

(async () => {
  const app = await createApplication(appConfig);
  const webComponentName = 'pu-floating-button-webcomponent';
  const createRequestFormName = 'pu-create-request-form-webcomponent';
  const aiChatPageWebComponentName = 'pu-ai-chat-page-webcomponent';

  if (!customElements.get(webComponentName)) {
    const appElement = createCustomElement(AppComponent, {
      injector: app.injector,
    });

    customElements.define(webComponentName, appElement);
  }

  if (!customElements.get(createRequestFormName)) {
    const createRequestFormElement = createCustomElement(SupportFormComponent, {
      injector: app.injector,
    });

    customElements.define(createRequestFormName, createRequestFormElement);
  }

  if (!customElements.get(aiChatPageWebComponentName)) {
    const aiChatPageElement = createCustomElement(AiChatPageComponent, {
      injector: app.injector,
    });

    customElements.define(aiChatPageWebComponentName, aiChatPageElement);
  }
})();
